import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable, BehaviorSubject, of, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  private documentsSource = new BehaviorSubject<any[]>([]);
  private idSource = new BehaviorSubject<number | null>(null);

  documents$ = this.documentsSource.asObservable();
  currentId$ = this.idSource.asObservable();

  getDocuments(
    id?: number,
    filterValues?: number[],
    language?: string,
    searchTerm?: string,
    page?: number,
    sort?: string,
  ): Observable<any> {
    if (id) {
      let url = `${this.apiData.apiURL}api/${this.client}/category/${id}/de/documents`;
      if (language) {
        url = `${this.apiData.apiURL}api/${this.client}/category/${id}/${language}/documents`;
      }
      if (!page || page == 0) {
        page = 1;
      }

      const body: Record<string, unknown> = {
        filter_values: filterValues,
        search_terms: searchTerm,
        limit: 24,
        page: page,
      };
      if (sort) {
        body['sort'] = sort;
      }

      return this.http.post(url, body).pipe(
        catchError((error) => {
          console.error('Error fetching document:', error);
          return throwError(() => new Error('Failed to load document'));
        }),
      );
    } else {
      return of([]);
    }
  }

  setId(id: number) {
    this.idSource.next(id);
  }
}
